module.exports = __webpack_public_path__ + "static/media/company-green.66c759ef.png";